/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import OrgUserForm from './OrgUserForm';
import { editOrgUsers } from '../../../../../../../services/organization/OrgUsers';
import { getAllOrgsUsers, getAllOrgsUsersByOrgID } from '../../../../../../../store/reducers/organization/orgUsers/orgUsersAction';
import { useParams } from 'react-router-dom';

const OrgUserEdit = ({ handleClose, selectedOrgUser }) => {
    const dispatch = useDispatch()
    const {orgid} = useParams()
    const handleSubmit = async ({ detailName, detailValue, roleID }, { setSubmitting }) => {
        try {
            setSubmitting(true)

            await editOrgUsers({
                organizationUserID: selectedOrgUser.organizationUserID, roleID, organizationUserDetails: [
                    {
                        detailName: detailName,
                        detailValue: detailValue
                    }]
            })
            toast.success('Organization User was edited successfully');
            handleClose();
            if (orgid?.length > 0) {
                await dispatch(getAllOrgsUsersByOrgID({ 'organizationID': orgid })).unwrap()

            } else {
                await dispatch(getAllOrgsUsers()).unwrap();
            }
            setSubmitting(false)

        } catch (error) {
            setSubmitting(false)
            toast.error(error?.response?.data?.error?.message);
        }
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Organization User Edit</Typography>
            <Formik
                initialValues={{
                    organizationID: selectedOrgUser.organizationID,
                    roleID: selectedOrgUser.roleID,
                    detailName: selectedOrgUser.organizationUserDetails[0].detailName,
                    detailValue: selectedOrgUser.organizationUserDetails[0].detailValue,

                }}
                validationSchema={Yup.object().shape({
                    organizationID: Yup.string().required('Organization is required.'),
                    roleID: Yup.string().required('Role is required.')


                })}
                onSubmit={(
                    values, { setSubmitting }
                ) => {
                    handleSubmit(values, { setSubmitting })
                }
                }
            >
                {({ values, handleBlur, handleChange, setFieldValue, isSubmitting, errors, touched }) => (
                    <OrgUserForm
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        isSubmitting={isSubmitting}
                        handleClose={handleClose}
                        errors={errors}
                        touched={touched} />
                )}
            </Formik>
        </>
    )

}


export default OrgUserEdit;